import { render, staticRenderFns } from "./Gshop.vue?vue&type=template&id=8c8d0da4&scoped=true&"
import script from "./Gshop.vue?vue&type=script&lang=js&"
export * from "./Gshop.vue?vue&type=script&lang=js&"
import style0 from "./Gshop.vue?vue&type=style&index=0&id=8c8d0da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8d0da4",
  null
  
)

export default component.exports